import LocalizedStrings from 'react-localization';

import ru from './ru.json';
import en from './en.json';
import de from './de.json';
import pl from './pl.json';
import fr from './fr.json';
import ja from './ja.json';
import es from './es.json';
import pt from './pt.json';

let strings = new LocalizedStrings({
    ru: ru,
    en: en,
    de: de,
    pl: pl,
    fr: fr,
    ja: ja,
    es: es,
    pt: pt,

}, {logsEnabled: false});
export default strings
